import {
  BarcodeOutlined,
  CheckCircleFilled,
  DeleteOutlined,
  DotChartOutlined,
  ExclamationCircleFilled,
  EyeInvisibleFilled,
  MedicineBoxOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Button, Form, Input, InputNumber, message, Table } from "antd";
import { MedboxIcon } from "../../assets/images/medbox";

import React, { useState } from "react";
// import "./Equipe.css";
import { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { CheckIOType } from "../../enums/checkInOut.enum";
import { sharedInternalInfoState } from "../../recoil/atoms/sharedInternalAtom";
import { userInfoState } from "../../recoil/atoms/userInfoAtom";
import CheckinService from "../../services/checkin.service";
import {
  Checkin,
  CheckinInsertPayload,
  CheckinUpdatePayload,
  CheckoutInsertPayload,
  Component,
  Kit,
  RawJson,
} from "../../types/checkInOut.types";
import { customTableTitle } from "../../utils/tables.utils";

// CheckIO = Check In / Check Out
function CheckIO() {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const [userInfo] = useRecoilState(userInfoState);
  const [kitInfo, setKitInfo] = useState({} as Kit);
  const [sharedInfo, setSharedInfo] = useRecoilState(sharedInternalInfoState);
  const [dataSource, setDataSource] = useState([] as Kit[]);
  const [dataSourceKitComponents, setDataSourceKitComponents] = useState(
    [] as Component[]
  );
  const [note, setNote] = useState(kitInfo.checkin?.note || "");
  const handleChange = (e: any) => {
    setNote(e.target.value);
  };
  const [searchForm] = Form.useForm();

  const surgeryManagementUUID = location.state?.surgeryManagementUUID as string;
  const type = location.state?.type as string; // può essere check-in o check-out presenti in CheckIOType
  const isActiveSixsterIntegration = userInfo.matrixPar[
    "system.isActiveSixsterIntegration"
  ]
    ? Boolean(userInfo.matrixPar["system.isActiveSixsterIntegration"])
    : false;

  const getTailPathBe = (type: string) => {
    if (type === CheckIOType.CHECK_IN) {
      return "check-in";
    }
    return "check-out";
  };

  const tailPathBe = getTailPathBe(type);

  const loadData = async () => {
    console.log("Type", type);

    let kitsInBaselist: Kit[] = await CheckinService.getKits(
      sharedInfo.surgeryBaselistUUID,
      "06"
    ); // Prendo i kit dalla surgery baselist
    let kitsAlreadyCheckedIn = await CheckinService.getKitCheckedIn(
      surgeryManagementUUID
    ); // Prendo i kit checkati in
    // if we are in check out, we need to merge the kits already checked in with the kits already checked out
    let kits = [] as Kit[];

    kits = kitsInBaselist.map((el: Kit) => {
      let checkin = kitsAlreadyCheckedIn.find(
        (el2: Checkin) => el2.article.uuid === el.article.uuid
      );
      return {
        ...el,
        checkin,
      };
    });

    setDataSource(kits as unknown as Kit[]);
  };

  const getTextColor = (record: Kit) => {
    if (
      type === CheckIOType.CHECK_IN &&
      record.checkin &&
      record.checkin.uuid
    ) {
      return "text-green-600 font-bold";
    } else if (
      type === CheckIOType.CHECK_OUT &&
      record.checkin &&
      record.checkin.hasCheckOut
    ) {
      return "text-green-600 font-bold";
    } else if (
      type === CheckIOType.CHECK_OUT &&
      record.checkin &&
      !record.checkin.hasCheckOut
    ) {
      return "text-indigo-600 font-bold";
    } else {
      return "text-grey-600";
    }
  };

  const headerRender = (filter: Array<string> = []): ColumnsType<Kit> => {
    const cols: any = [
      {
        title: customTableTitle(`${t("CODE")}`, ""),
        dataIndex: "code_description",
        key: "code_description",
        width: "35px",

        render: (code: any, record: any) => (
          <div className={getTextColor(record)}>
            <div className="flex items-center">
              <div
                onClick={() => {
                  openModal(record);
                }}
                className="p-1 px-2 bg-teal-600 hover:bg-teal-700 cursor-pointer rounded-md font-bold text-white"
              >
                <MedboxIcon size="18"></MedboxIcon>
              </div>{" "}
              <span className="ml-4">
                {record.article.code} - {record.article.description}
              </span>
            </div>
          </div>
        ),
      },
      {
        title: customTableTitle(`${t("ACTION")}`, ""),
        dataIndex: "action",
        key: "action",
        width: "10px",
        render: (text: any, record: Kit) => (
          <div className="flex space-x-6">
            <Button
              type="primary"
              icon={<EyeInvisibleFilled />}
              className="font-black uppercase p-4"
              onClick={() => {
                openModal(record);
              }}
            ></Button>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              className="font-black uppercase bg-red-500"
              onClick={() => {
                manageDeletion(record);
              }}
            ></Button>
          </div>
        ),
      },
    ];

    if (filter.length > 0) {
      return cols.filter((col: any) => filter.includes(col.key));
    }
    return cols;
  };

  const highlight = (record: any) => {
    // get all elements in dataSourceKitComponents and set marked to true of selected element
    setDataSourceKitComponents((prev: any) => {
      return prev.map((el: any) => {
        if (el.id === record.id) {
          return { ...el, marked: !el.marked };
        }
        return el;
      });
    });
  };

  const headerRenderKitComponents = (
    filter: Array<string> = []
  ): ColumnsType<Component> => {
    const cols: any = [
      {
        title: customTableTitle(`${t("CHECKED")}`, ""),
        dataIndex: "marked",
        key: "marked",
        width: "100px",
        render: (text: any, record: any) => (
          <div
            className="cursor-pointer"
            style={{ fontSize: "28px" }}
            onClick={() => highlight(record)}
          >
            {record.marked ? (
              <div className="bg-green-300 rounded-md text-center">
                <CheckCircleFilled className="text-green-500"></CheckCircleFilled>
              </div>
            ) : (
              <div className="bg-red-300 rounded-md text-center">
                <ExclamationCircleFilled className="text-red-500"></ExclamationCircleFilled>
              </div>
            )}
          </div>
        ),
      },
      {
        title: customTableTitle(`${t("CODE")}`, ""),
        dataIndex: "code_description",
        key: "code_description",
        width: "70%",
        render: (code: any, record: any) => (
          <div>
            {record.productCode} - {record.productDescription}
          </div>
        ),
      },
      // amount
      {
        title: customTableTitle(`${t("QUANTITY")}`, ""),
        dataIndex: "amount",
        key: "amount",
      },
      //actual quantity
      {
        title: customTableTitle(`${t("ACTUAL_QUANTITY")}`, ""),
        dataIndex: "actual_quantity",
        key: "actual_quantity",
        render: (code: any, record: any) => (
          <div>
            <InputNumber
              size="large"
              type="number"
              min={0}
              defaultValue={
                record.actualQuantity ? Number(record.actualQuantity) : 0
              }
              placeholder={`${t("ACTUAL_QUANTITY")}`}
              onChange={(value) => {
                updateActualQuantity(record.id, value);
              }}
            />
          </div>
        ),
      },
    ];

    if (filter.length > 0) {
      return cols.filter((col: any) => filter.includes(col.key));
    }
    return cols;
  };

  const [columns, setColumns] = useState(headerRender());
  const [columnsKitComponents, setColumnsKitComponents] = useState(
    headerRenderKitComponents()
  );

  React.useEffect(() => {
    if (!type) {
      console.error("Function type is not defined");
      return;
    }
    console.log("Requested type: ", type);
    loadData();
  }, [type]);

  React.useEffect(() => {
    closeModal();
  }, [type]);

  React.useEffect(() => {
    if (isActiveSixsterIntegration) {
      if (kitInfo.article && kitInfo.article.code && kitInfo.article.barcode) {
        loadKitComponents(kitInfo.article.barcode, kitInfo.article.code);
      } else {
        console.error("Article code or barcode is not defined");
      }
    } else {
      console.warn("Sixster integration is not active!!");
    }
  }, [kitInfo]);

  const setActualQuantity = (checkin: any, el: any) => {
    if (checkin && Object.keys(checkin).length > 0) {
      return Number(checkin.actualQuantity);
    } else if (el.amount) {
      return Number(el.amount);
    } else {
      return 0;
    }
  };

  const loadKitComponents = async (barcode: string, kitCode: string) => {
    let components = await CheckinService.getKitComponents({
      barcode,
      code: kitCode,
    });
    let rawjson: RawJson[] = [];

    if (
      (type === CheckIOType.CHECK_IN &&
        kitInfo.checkin &&
        kitInfo.checkin.uuid) ||
      (type === CheckIOType.CHECK_OUT &&
        kitInfo.checkin &&
        !kitInfo.checkin.hasCheckOut)
    ) {
      // prendo il rawjson dal checkin se sono in checkin ed esiste oppure se sono in checkout e non esiste il checkout
      rawjson = kitInfo?.checkin?.rawjson;
    } else if (
      type === CheckIOType.CHECK_OUT &&
      kitInfo.checkin &&
      kitInfo.checkin.hasCheckOut
    ) {
      // prendo il rawjson dal checkout se sono in checkout e esiste
      rawjson = kitInfo?.checkin?.sixterKitCheckOut?.rawjson;
    } else {
      // oops...qualcosa è andato storto
      console.error("Checkin is not defined");
    }

    components = components.map((el: any) => {
      let checkin = rawjson.find((el2: any) => el2.code === el.productCode);
      return {
        ...el,
        actualQuantity: setActualQuantity(checkin, el),
      };
    });

    setDataSourceKitComponents(components);
  };

  const openModal = (record: Kit) => {
    let note = "";

    if (type === CheckIOType.CHECK_IN) {
      note = record.checkin?.note || "";
    } else if (type === CheckIOType.CHECK_OUT) {
      note =
        record.checkin?.sixterKitCheckOut?.note || record.checkin?.note || "";
    }

    setNote(note);
    setKitInfo(record);
  };

  const updateActualQuantity = (id: string, value: number | null) => {
    setDataSourceKitComponents((prev: any) => {
      return prev.map((el: any) => {
        if (el.id === id) {
          return { ...el, actualQuantity: value || 0 };
        }
        return el;
      });
    });
  };

  const saveData = async () => {
    let notes = document.getElementById("notes") as HTMLInputElement;
    let rawjson = dataSourceKitComponents.map((el: any) => {
      return {
        code: el.productCode,
        description: el.productDescription,
        quantity: el.amount ? Number(el.amount) : 0,
        actualQuantity: el.actualQuantity ? Number(el.actualQuantity) : 0,
      };
    });

    if (type === CheckIOType.CHECK_IN) {
      saveCheckIn(rawjson, notes);
    } else if (type === CheckIOType.CHECK_OUT) {
      saveCheckOut(rawjson, notes);
    }
  };

  const saveCheckIn = (rawjson: RawJson[], notes: HTMLInputElement) => {
    if (kitInfo.checkin && kitInfo.checkin.uuid) {
      // update
      let updatePayload: CheckinUpdatePayload = {
        surgeryManagement: surgeryManagementUUID,
        article: kitInfo.checkin.article.uuid,
        sixterId: kitInfo.checkin.sixterId,
        rawjson,
        note: notes.value,
      };

      CheckinService.update(tailPathBe, kitInfo.checkin.uuid, updatePayload)
        .then((response: any) => {
          closeModal();
          loadData();
        })
        .catch((error: any) => {
          console.error("updateCheckIn", error);
        });
    } else {
      // create
      const insertPayload: CheckinInsertPayload = {
        kits: [
          {
            surgeryManagement: surgeryManagementUUID,
            article: kitInfo.article.uuid,
            sixterId: kitInfo.article.code,
            rawjson,
            note: notes.value,
          },
        ],
      };
      CheckinService.save(tailPathBe, insertPayload)
        .then((response: any) => {
          console.log(`Saving ${type}`, response);
          closeModal();
          loadData();
        })
        .catch((error: any) => {
          console.error(`Error while saving: `, error);
        });
    }
  };

  const saveCheckOut = (rawjson: RawJson[], notes: HTMLInputElement) => {
    if (kitInfo.checkin && kitInfo.checkin.hasCheckOut) {
      // update
      let updatePayload: CheckinUpdatePayload = {
        surgeryManagement: surgeryManagementUUID,
        article: kitInfo.checkin.article.uuid,
        sixterId: kitInfo.checkin.sixterId,
        rawjson,
        note: notes.value,
      };

      CheckinService.update(
        tailPathBe,
        kitInfo.checkin.sixterKitCheckOut.uuid,
        updatePayload
      )
        .then((response: any) => {
          console.log(`Saving ${type}`, response);
          closeModal();
        })
        .catch((error: any) => {
          console.error("updateCheckOut", error);
        })
        .finally(() => {
          loadData();
        });
    } else {
      // create
      const insertPayload: CheckoutInsertPayload = {
        kits: [
          {
            sixterKitCheckIn: kitInfo.checkin.uuid,
            rawjson,
            note: notes.value,
          },
        ],
      };
      CheckinService.save(tailPathBe, insertPayload)
        .then((response: any) => {
          console.log(`Saving ${type}`, response);
          closeModal();
        })
        .catch((error: any) => {
          console.error(`Error while saving: `, error);
        })
        .finally(() => {
          loadData();
        });
    }
  };

  const manageDeletion = (record: Kit) => {
    let uuid;
    switch (type) {
      case CheckIOType.CHECK_IN.toString(): {
        if (!record.checkin.uuid) return;
        uuid = record.checkin.uuid;
        cancel(uuid);
        break;
      }
      case CheckIOType.CHECK_OUT.toString(): {
        if (!record.checkin.sixterKitCheckOut.uuid) return;
        uuid = record.checkin.sixterKitCheckOut.uuid;
        cancel(uuid);
        break;
      }
    }
  };

  const cancel = (uuid: string) => {
    CheckinService.cancel(tailPathBe, uuid)
      .then((response: { delete: number }) => {
        closeModal();
        loadData();
      })
      .catch((error: any) => {
        message.error(t("INTERNAL_SERVER_ERROR"));
      });
  };

  const searchBarcode = async (barcode: string) => {
    if (!barcode) return;
    console.log("searchBarcode", barcode);
    searchForm.setFieldValue("search", "");

    if (kitInfo && kitInfo.uuid) {
      closeModal();
    }

    let current = dataSource.find((el: Kit) => el.article.barcode === barcode);

    if (current) {
      openModal(current);
    } else {
      message.error(t("BARCODE_NOT_FOUND"));
    }
  };

  const closeModal = () => {
    setColumns(headerRender());
    setColumnsKitComponents(headerRenderKitComponents());
    setDataSourceKitComponents([]);
    setNote("");
    setKitInfo({} as Kit);
  };

  return (
    <>
      <div className="page-container-margin">
        <div className="page-menu-container flex items-center justify-between">
          <div className="flex items-center px-4">
            {kitInfo.uuid && (
              <>
                <div className="flex items-center mr-4">
                  <Button
                    type="primary"
                    danger
                    icon={<EyeInvisibleFilled />}
                    className="font-black uppercase"
                    onClick={() => {
                      closeModal();
                    }}
                  ></Button>
                </div>
                <h2 className="text-2xl font-bold text-teal-700">
                  {kitInfo?.article?.code} - {kitInfo?.article?.description}
                </h2>
              </>
            )}
          </div>
          <Form form={searchForm} layout="inline">
            <Form.Item
              style={{ margin: 0 }}
              name="search"
              className="form-container-item"
            >
              <Input
                id="search-and-decode-barcode"
                addonBefore={<BarcodeOutlined className="text-teal-700" />}
                addonAfter={<SearchOutlined className="text-teal-700" />}
                placeholder={`${t("SEARCH")}`}
                onKeyUp={(e: any) => {
                  if (e.key === "Enter") {
                    searchBarcode(e.target.value);
                  }
                }}
                style={{ width: 304 }}
                allowClear
              />
            </Form.Item>
          </Form>
        </div>
        <div>
          {!kitInfo.uuid && (
            <div className="mt-4">
              <div className="sisos-table-container">
                <Table
                  size="small"
                  showHeader={true}
                  className="sisos-table"
                  columns={columns}
                  sticky={true}
                  // rowClassName="surgery-row"
                  pagination={{
                    pageSize: window.innerHeight > 900 ? 7 : 14,
                    hideOnSinglePage: true,
                  }}
                  dataSource={dataSource}
                />
              </div>
            </div>
          )}
          {kitInfo.uuid && (
            <div className="ml-4 details-container rounded-md">
              <div className="flex justify-between items-center  border-b-2 border-gray-500">
                <div className="flex items-center"></div>
              </div>
              <hr className="border-b-1 border-teal-500 bg-transparent opacity-30" />
              {isActiveSixsterIntegration && (
                <>
                  <div className="rounded-md text-teal-700">
                    {isActiveSixsterIntegration && (
                      <div className="sisos-table-container">
                        <Table
                          size="small"
                          showHeader={true}
                          className="sisos-table"
                          columns={columnsKitComponents}
                          sticky={true}
                          pagination={{
                            pageSize: window.innerHeight < 900 ? 7 : 14,
                            hideOnSinglePage: true,
                            position: ["topCenter"],
                          }}
                          dataSource={dataSourceKitComponents}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
              <div className="mt-4  p-4 rounded-md text-teal-700">
                <Input.TextArea
                  id="notes"
                  placeholder={t("NOTES")}
                  value={note}
                  onChange={handleChange}
                />
              </div>

              <Button
                type="primary"
                className="customButton"
                block
                onClick={() => {
                  saveData();
                }}
              >
                {t("SAVE")}
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default CheckIO;
